export function isPersonaInCompanyCategory(
  persona: { category?: string },
  companyName: string
): boolean {
  return companyName === "Gargantua" || persona.category === companyName;
}
